import { Button, Flex, Text } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	onConfirm: () => void;
	onCancel: () => void;
}

export const DocumentReviewStep = ({ onConfirm, onCancel }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Flex direction="column" gap="md" w="100%" pl="1.25rem" pr="1.25rem">
			<Text size="sm">{tCommonUi('eid_easy_signing.document_review_prompt')}</Text>
			<Flex gap="sm" justify="flex-end">
				<Button variant="subtle" onClick={onCancel}>
					{tCommonUi('common_buttons.cancel')}
				</Button>
				<Button variant="filled" onClick={onConfirm}>
					{tCommonUi('eid_easy_signing.document_review_sign_button')}
				</Button>
			</Flex>
		</Flex>
	);
};
